// Antetul popup-urilor de personal (instructor, manager, admin, profesor și „… nou”): rândul de
// sticlă ca la elev (studentItem: avatarul, numele, dedesubt titlul — „Instructor de examen”).
// Fotografia, ca notița la elev: creionul din dreapta rândului deschide meniul (DropdownUI) —
// „Vezi poza”, „Schimbă poza” / „Adaugă poză”, „Șterge poza”; apăsat, avatarul arată poza (sau,
// fără poză, o alege). Logica pozei: useProfilePhoto (aceeași la elev).
// Fără photo: doar avatarul, numele și titlul.
import React from "react";

import { AvatarUI, DropdownUI } from "../../UI";
import useProfilePhoto from "./useProfilePhoto";

export default function StaffProfileHead({
   person = null,
   color,
   initials,
   name,
   subtitle,
   photo = null,
   className = "",
}) {
   const avatar = (extraClass, preview) => (
      <AvatarUI
         person={person}
         src={preview || undefined}
         color={color}
         initials={initials}
         size={null}
         className={extraClass}
      />
   );
   const ph = useProfilePhoto(photo, {
      name,
      renderPhoto: (cls) => avatar(cls, photo?.mode === "local" ? photo.previewUrl : null),
   });
   const metaText = ph.status.text || subtitle || "";

   return (
      <div className={`studentItem staffProfileHead ${className}`.trim()}>
         {ph.enabled ? (
            <button
               type="button"
               className={"staffProfileHead__avatarBtn" + (ph.busy ? " is-busy" : "")}
               onClick={() => (ph.hasPhoto ? ph.openView() : ph.pick())}
               disabled={ph.busy}
               aria-label={ph.hasPhoto ? "Vezi poza" : "Adaugă poză"}
               title={ph.hasPhoto ? "Vezi poza" : "Adaugă poză"}
            >
               {avatar("studentItem__avatar", ph.localPreview)}
            </button>
         ) : (
            avatar("studentItem__avatar")
         )}

         <div className="studentItem__info">
            <h3 className="studentItem__name">{name || "–"}</h3>
            <p
               className={
                  "studentItem__meta staffProfileHead__meta" + (ph.status.kind ? ` is-${ph.status.kind}` : "")
               }
               role={ph.status.text ? "status" : undefined}
            >
               {metaText || "—"}
            </p>
         </div>

         {/* ca creionul notiței la elev: meniul pozei */}
         {ph.enabled ? (
            <DropdownUI
               className="staffProfileHead__menu"
               icon="edit"
               label=""
               chevrons={false}
               align="end"
               disabled={ph.busy}
               aria-label="Fotografia"
               options={ph.menuOptions}
               onChange={ph.onMenu}
            />
         ) : null}

         {ph.elements}
      </div>
   );
}
